exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.controls-container[data-v-0049d3a2] {\n    background: #FAFAFA;\n}\n.main-container .controls-container[data-v-0049d3a2] {\n    margin-right: -1rem;\n    margin-left: -1rem;\n    padding: 1rem;\n}\n", ""]);

// exports
